import React from 'react';

const Selected = () => {
  return (
    <svg width="23" height="23" viewBox="0 0 23 23">
      <g id="check">
        <g id="First">
          <circle id="Ellipse_14" dataname="Ellipse 14" cx="11.5" cy="11.5" r="11.5" fill="#ec1c24" opacity="0.93"/>
        </g>
        <path id="Union_9" dataname="Union 9" d="M-866.451-197l-7.535,5.619ZM-877-193.7l3.013,2.314Z" transform="translate(883.548 206.172)" fill="none" stroke="#fff" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2"/>
      </g>
    </svg>
  );
}

export default Selected;